import React,{Fragment,useEffect ,useState} from 'react'
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
} from 'mdb-react-ui-kit';
import ClipLoader from "react-spinners/ClipLoader";

import Footer from "../component/layout/footer";
import Header from "../component/layout/header";
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import baseURL, { getAuthHeaders, getAuthToken, fetchAuthToken } from '../api/index';
import InputMask from 'react-input-mask';

const InqueryForm = () => {

  const [basicModal, setBasicModal] = useState(false);

  
  const [Ccountry , setCcountry] = useState([]);
  const [getcCountryID , setGetcCountryID] = useState(1);
  const [allInquiryData , setAllInquiryData] = useState({cCountryId : 1})
  
  const [Cprovince , setCprovince] = useState([])
  const [getCurProvinceID,setGetCurProvinceID] = useState('')

  const [curCities , setCurCities] = useState([])

  // permanant address states
  const [perCountry, setPerCountry] = useState([])
  const [perCountryID , setPerCountryID] = useState(1)

  const [perProvince , setPerProvince] = useState([])
  const [perProvinceID, setPerProvinceID] = useState('')

  const [perCity , setPerCity] = useState([])


  const [getreligon,setReligon] = useState([])
  const [montherTonges,setMotherTonge] = useState([])
  const [grades , setGrade] = useState([])
  const [sessions,setSessions] = useState([])
  const [references,setReference] = useState([])
  const [isSuccesMsg ,setIsSuccessMsg] = useState('')
  const [isSubmited, setIsSubmited] = useState(false);
  const [campuses ,setCampuses]  = useState([])


  const HandleCountry = async(e) =>{
    const getCountryId = e.target.value
    setGetcCountryID(getCountryId)
    setAllInquiryData({...allInquiryData , [e.target.name]: e.target.value})
       
  }

  const HandlePerCountry = async(e) =>{
    const getPerCountryId = e.target.value
    setPerCountryID(getPerCountryId)
    setAllInquiryData({...allInquiryData , [e.target.name]: e.target.value})
  }

  const HandleCurProvince = async(e) =>{
    const getCurProvinceID = e.target.value
    setGetCurProvinceID(getCurProvinceID)
    setAllInquiryData({...allInquiryData , [e.target.name]: e.target.value})
  }

  const HandlePerProvince = async(e) =>{
    const getPerProvinceID = e.target.value
    setPerProvinceID(getPerProvinceID)
    setAllInquiryData({...allInquiryData , [e.target.name]: e.target.value})
  }

  const [emailerr ,setEmailErr] = useState(false)
  console.log(emailerr)
  const HandleOnChangeValues = async(e) =>{
    e.preventDefault(e)
    
    const value = e.target.value
    setAllInquiryData({...allInquiryData , [e.target.name]: value})
    if(e.target.name === 'email'){
      const value = e.target.value
      const reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if(reg.test(value)){
            
            setEmailErr(false)
            console.log('value')
        }else{
            setEmailErr(true)
        }
    }
  }

  const [saveAllData , setSaveAllData]=useState('')
  const [loader , setLoader] = useState(false)
  const navigate = useNavigate()
  
  const HandleDataSubmit = async(e) =>{
    e.preventDefault()
    try {
      const res = await axios.post(`${baseURL}/api/inquiry/addinquiry`, allInquiryData, {
        headers: getAuthHeaders()
      })
      const data = res.data
      setIsSuccessMsg(data.message)
      setSaveAllData(data.data)
      setIsSubmited(true)
      setBasicModal(true)
    } catch (error) {
      console.log(error)
    }
  }
  


  useEffect(() => {
    if(saveAllData){
        const timer = setTimeout(() => {
            navigate('/')
        }, 3000);
        return () => clearTimeout(timer);
    }
  }, [saveAllData]);
  

  useEffect(() => {
    const getInitialData = async () => {
      try {
        const token = await getAuthToken();
        const authHeaders = token
          ? { Authorization: token, accessToken: token, token: token }
          : getAuthHeaders();

        const countryRes = await axios.get(`${baseURL}/api/Address/GetCountries`, {
          headers: authHeaders
        });
        if (countryRes.data?.data) {
          setCcountry(countryRes.data.data);
          setPerCountry(countryRes.data.data);
          const pak = countryRes.data.data.find(c => c.id === 1) || countryRes.data.data[0];
          if (pak) {
            setGetcCountryID(pak.id);
            setPerCountryID(pak.id);
            setAllInquiryData(prev => ({ ...prev, cCountryId: pak.id }));
          }
        }

        const campusBody = {
          pageNo: 1,
          pageSize: 100,
          campusName: "",
          isEnabled: true
        };
        const campusRes = await axios.post(`${baseURL}/api/Campus/GetAll`, campusBody, {
          headers: authHeaders
        });
        if (campusRes.data?.data) {
          setCampuses(campusRes.data.data);
        }

        const religionRes = await axios.get(`${baseURL}/api/religion/getreligions`, {
          headers: authHeaders
        });
        if (religionRes.data?.data) setReligon(religionRes.data.data);

        const tongueRes = await axios.get(`${baseURL}/api/tonge/getmothertonges`, {
          headers: authHeaders
        });
        if (tongueRes.data?.data) setMotherTonge(tongueRes.data.data);

        // Fetch Current Session with token from login account response (without Bearer prefix)
        try {
          const sessionRes = await axios.get(`${baseURL}/api/Session/GetCurrentSession`, {
            headers: authHeaders
          });
          if (sessionRes.data?.data) {
            const sessionData = sessionRes.data.data;
            const sessionList = Array.isArray(sessionData) ? sessionData : [sessionData];
            setSessions(sessionList);
            const activeSession = sessionList.find(s => s.isActive) || sessionList[0];
            if (activeSession?.id) {
              setAllInquiryData(prev => ({ ...prev, sessionId: activeSession.id }));
            }
          }
        } catch (sessionError) {
          console.error("Error fetching current session:", sessionError);
        }

        const gradeRes = await axios.get(`${baseURL}/api/Grade/GetGrades`, {
          headers: authHeaders
        });
        if (gradeRes.data?.data) setGrade(gradeRes.data.data);

        const refRes = await axios.get(`${baseURL}/api/reference/getreferences`, {
          headers: authHeaders
        });
        if (refRes.data?.data) setReference(refRes.data.data);
      } catch (error) {
        console.log("Error loading initial inquiry form data:", error);
      }
    };
    getInitialData();
  }, []);

  useEffect(() => {
    if (getcCountryID) {
      axios.get(`${baseURL}/api/Address/GetProvinceByCountry?countryId=${getcCountryID}`, {
        headers: getAuthHeaders()
      })
        .then(res => setCprovince(res.data?.data || []))
        .catch(err => console.log(err));
    }
  }, [getcCountryID]);

  useEffect(() => {
    if (perCountryID) {
      axios.get(`${baseURL}/api/Address/GetProvinceByCountry?countryId=${perCountryID}`, {
        headers: getAuthHeaders()
      })
        .then(res => setPerProvince(res.data?.data || []))
        .catch(err => console.log(err));
    }
  }, [perCountryID]);

  useEffect(() => {
    if (getCurProvinceID) {
      axios.get(`${baseURL}/api/Address/GetCityByProvince?provinceId=${getCurProvinceID}`, {
        headers: getAuthHeaders()
      })
        .then(res => setCurCities(res.data?.data || []))
        .catch(err => console.log(err));
    }
  }, [getCurProvinceID]);

  useEffect(() => {
    if (perProvinceID) {
      axios.get(`${baseURL}/api/Address/GetCityByProvince?provinceId=${perProvinceID}`, {
        headers: getAuthHeaders()
      })
        .then(res => setPerCity(res.data?.data || []))
        .catch(err => console.log(err));
    }
  }, [perProvinceID]);
  return (
    <Fragment>
          <Header />
            
            <MDBModal show={basicModal} setShow={setBasicModal} tabIndex='-1'>
                <MDBModalDialog>
                <MDBModalContent>
                    <MDBModalHeader>
                    <MDBModalTitle><h2 className='text-success'>Congratulations!</h2></MDBModalTitle>
                    
                    </MDBModalHeader>
                    <MDBModalBody>
                        <h5>Your application has been successfully submitted.</h5>
                        
                    </MDBModalBody>
                </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
          <div className="pageheader-section style-2 mb-20">
            <div className="container">
                  {loader ? 
                    <div className="row">
                      <center>
                                <MDBModal show={true} tabIndex='-1'>
                                    <div style={{position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)"}}>
                                        <ClipLoader
                                            marginTop={300}
                                            color={'#fff'}
                                            loading={loader}
                                            size={70}
                                            aria-label="Loading Spinner"
                                            data-testid="loader"
                                        />
                                    </div>
                                </MDBModal>
                      </center>
                    </div>
                  : null }
                <div className="row justify-content-center justify-content-lg-between align-items-center flex-row-reverse">
                    {isSubmited ? 
                      <h4 className='text-success'><center>{isSuccesMsg}</center></h4>
                    : null}
                    <center>
                      <p style={{fontSize:16}}><strong>Note:</strong><span style={{color:'red'}}> * </span> Please fill out the form below and our Admissions Office will contact you and provide the information you desire.</p>
                    </center>
                    <form onSubmit={HandleDataSubmit} id="create-course-form" className='form'>
                      <h5 className='mt-4'>Select Campus</h5>
                      
                      <div className='row'>
                        <input type='hidden'  name='inquiryNo' value='0' />
                        
                        <div className='col-md-12'>
                            
                            <div className='form-group'>
                                <select className='form-control' name='campusId' required onChange={HandleOnChangeValues}>
                                  <option value=''>-select campus-</option>        
                                  {campuses?.map(item =>(
                                    <option key={item.id} value={item.id}>{item.name}, {item.cityName}</option>
                                  ))}            
                                </select>
                            </div>
                        </div>

                        <h5 className='mt-4'>Information</h5>


                        <div className='col-md-6 mt-3'>
                            <label style={{fontWeight: 550}}>Session <span className='text-danger'>*</span></label>
                            <div className='form-group'>
                                <select  
                                  value={allInquiryData?.sessionId || sessions[0]?.id || ''}
                                  className='form-control' 
                                  name='sessionId' 
                                  required 
                                  onChange={HandleOnChangeValues}
                                  disabled={true}
                                >
                                  <option value=''>-select-</option>        
                                  {sessions.map((session,index)=>(
                                      <option key={index} value={session.id}>{session.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='col-md-6 mt-3'>
                            <label className='text-center' style={{fontWeight: 550}}>Grade <span className='text-danger'>*</span></label>
                            <div className='form-group'>
                                <select className='form-control' name='gradeId' required onChange={HandleOnChangeValues}>
                                  <option value=''>-select-</option>
                                    {grades.map((grade,index)=>(
                                      <option key={index} value={grade.id} >{grade.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        
                        
                        <div className='col-md-6 mt-3'>
                          <label style={{fontWeight: 550}}>First Name: <span className='text-danger'>*</span> </label>
                          <div className='form-group'>
                            <input required className='form-control'  name='firstName' onChange={HandleOnChangeValues} placeholder='Enter First Name' />
                          </div>
                        </div>
                        <div className='col-md-6 mt-3'>
                          <label style={{fontWeight: 550}}>Middle Name: </label>
                          <div className='form-group'>
                            <input className='form-control' onChange={HandleOnChangeValues} name='middleName'  placeholder='Enter Middle Name' />
                          </div>
                        </div>
                        <div className='col-md-6 mt-3'>
                          <label className='label' style={{fontWeight: 550}}>Last Name: <span className='text-danger'>*</span></label>
                          <div className='form-group'>
                            <input className='form-control' onChange={HandleOnChangeValues} required name='familyName'  placeholder='Enter Last Name' />
                          </div>
                        </div>
                        <div className='col-md-6 mt-3'>
                          <label className='label' style={{fontWeight: 550}}>Date of Birth: <span className='text-danger'>*</span></label>
                          <div className='form-group'>
                            <input className='form-control' onChange={HandleOnChangeValues} required type='date' name='dateOfBirth'  placeholder='Date of Birth' />
                          </div>
                        </div>

                        <div className='col-md-6 mt-3'>
                          <label className='label' style={{fontWeight: 550}}>Father Name: <span className='text-danger'>*</span></label>
                          <div className='form-group'>
                            <input className='form-control' onChange={HandleOnChangeValues} type='text' required name='fatherName'  placeholder='Enter Father Name' />
                          </div>
                        </div>

                        <div className='col-md-6 mt-3'>
                          <label className='label' style={{fontWeight: 550}}>Father Email: 
                            <span className='text-danger'>
                              * {emailerr? <>Please Enter Valid Email</> : null}
                                    
                            </span>
                          </label>
                          <div className='form-group'>
                            <input className='form-control' onChange={HandleOnChangeValues} type='email' required name='email'  placeholder='Enter Father Email' />
                          </div>
                        </div>
                        <div className='col-md-6 mt-3'>
                          <label className='label' style={{fontWeight: 550}}>Father CNIC: <span className='text-danger'>*</span></label>
                          <div className='form-group'>
                            <InputMask mask="99999-9999999-9" name='cnic' onChange={HandleOnChangeValues} className='form-control' placeholder="XXXXX-XXXXXXX-X" required />
                          </div>
                        </div>  


                        <div className='col-md-6 mt-3 mb-5'>
                          <label className='label' style={{fontWeight: 550}}>Whatsapp No: <span className='text-danger'>*</span> </label>
                          <div className='form-group'>
                            <InputMask mask="+99999-9999999" className='form-control' onChange={HandleOnChangeValues} name='contactNumber' required placeholder='+92321-1234567' />
                          </div>
                        </div>

                        
                        <hr/>
                        <h5 className='mb-4'>Address Information</h5>
                        <div className='col-md-6 mt-3'>
                          <label style={{fontWeight: 550}}>Country <span className='text-danger'>*</span></label>
                          <div className='form-group'>
                            <select value={allInquiryData?.cCountryId} onChange={HandleCountry} required className='form-control' name='cCountryId'>
                              <option>-select-</option>
                              {Ccountry?.map((cCountryData,index)=>(
                                <option key={index} value={cCountryData.id}
                                
                                >
                                  {cCountryData.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className='col-md-6 mt-3'>
                          <label style={{fontWeight: 550}}>State <span className='text-danger'>*</span> </label>
                          <div className='form-group'>
                            <select onChange={HandleCurProvince} required className='form-control' name='cProvinceId'>
                              <option>-select-</option>
                              {Cprovince.map((cProvinceData,index) =>(
                                <option key={index} value={cProvinceData.id}>{cProvinceData.name}</option>
                              ))}
                                
                            </select>
                          </div>
                        </div>
                        <div className='col-md-6 mt-3'>
                          <label style={{fontWeight: 550}}>City <span className='text-danger'>*</span> </label>
                          <div className='form-group'>
                            <select className='form-control' name='cCityId' required onChange={HandleOnChangeValues}>
                              <option>-select-</option>
                              {curCities.map((curCityData,index) =>(
                                <option key={index} value={curCityData.id}>
                                  {curCityData.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className='col-md-6 mt-3'>
                          <label className='label' style={{fontWeight: 550}}>House No <span className='text-danger'>*</span></label>
                          <div className='form-group'>
                            <input className='form-control' onChange={HandleOnChangeValues} required name='cHouseNo'  placeholder='House no' />
                          </div>
                        </div>
                        <div className='col-md-6 mt-3'>
                          <label className='label' style={{fontWeight: 550}}>Street No <span className='text-danger'>*</span></label>
                          <div className='form-group'>
                            <input className='form-control' onChange={HandleOnChangeValues} required name='cStreetNo'  placeholder='Street  No' />
                          </div>
                        </div>
                        <div className='col-md-6 mt-3 mb-5'>
                          <label className='label' style={{fontWeight: 550}}>Town <span className='text-danger'>*</span></label>
                          <div className='form-group'>
                            <input className='form-control' onChange={HandleOnChangeValues} required name='cTown'  placeholder='Town' />
                          </div>
                        </div>
                        
                        <hr />
                        <div className='col-md-2'></div>
                        <div className='col-md-8'>
                          <h5>Reference</h5>
                            <label className='label' style={{fontWeight: 550}}>How did you hear about us?<span className='text-danger'>*</span></label>
                            <div className='form-group'>
                              <select name='referenceId' onChange={HandleOnChangeValues} required className='form-control'>
                                <option value=''>-select-</option>
                                {references.map((refr , index) =>(
                                  <option key={index} value={refr.id}>{refr.name}</option>
                                ))}
                              </select>
                            </div>
                        </div>
                        <div className='col-md-2'></div>
                        <div className='col-md-12 my-5 '>
                          <center>
                            <button className='btn btn-success' disabled={emailerr ? true : false}> <i className='icofont-save'></i> Save</button>
                          </center>
                        </div>
                      </div>
                    </form>
                </div>
            </div>
          </div>

          <Footer />
    </Fragment>
    
  )
}

export default InqueryForm